var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',[_c('a-tabs',{model:{value:(_vm.tabActive),callback:function ($$v) {_vm.tabActive=$$v},expression:"tabActive"}},[_c('a-tab-pane',{key:1,attrs:{"tab":"普通内容"}},[_c('GeneralContent')],1),(_vm.isExperience)?_c('a-tab-pane',{key:2,attrs:{"tab":"体验内容"}},[_c('ExperienceContent')],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }